import React from "react";

// Stat labels - the label-column content for the Tracked Results row-
// group's [label|body] pair in CalendarView's .planner-grid. The chevron/
// title bar above this (always visible, even while these rows are hidden by
// collapse) is its own full-width row (PlannerTitleRow.js) - see that
// file's comment for why they're split.
export const AthleteStatsHeader = ({ athleteStatsHeaders }) => (
  <div className="athlete-stats-header">
    {athleteStatsHeaders.map((stat, index) => (
      <span key={`stat-${index}`} className="row-header">
        {stat}
      </span>
    ))}
  </div>
);
